import httpClient from './httpClient';

const configuracionTareoService = {
  // Obtener tipos de tareo disponibles
  async obtenerTiposTareo() {
    try {
      const response = await httpClient.get('/configuracion-tareo/tipos');
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('Error al obtener tipos de tareo:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener tipos de tareo'
      };
    }
  },

  // Obtener configuración de tareo de una empresa
  async obtenerConfiguracionTareo(empresaId) {
    try {
      const response = await httpClient.get(`/configuracion-tareo/empresa/${empresaId}`);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('Error al obtener configuración de tareo:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener configuración de tareo'
      };
    }
  },

  // Crear configuración de tareo
  async crearConfiguracionTareo(empresaId, tipoTareo, descontarDescansos = true) {
    try {
      const response = await httpClient.post('/configuracion-tareo', {
        empresa_id: empresaId,
        tipo_tareo: tipoTareo,
        descontar_descansos: descontarDescansos
      });
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      console.error('Error al crear configuración de tareo:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al crear configuración de tareo',
        errors: error.response?.data?.errors
      };
    }
  },

  // Actualizar configuración de tareo
  async actualizarConfiguracionTareo(empresaId, tipoTareo, descontarDescansos = true) {
    try {
      const response = await httpClient.put(`/configuracion-tareo/empresa/${empresaId}`, {
        tipo_tareo: tipoTareo,
        descontar_descansos: descontarDescansos
      });
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      console.error('Error al actualizar configuración de tareo:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al actualizar configuración de tareo',
        errors: error.response?.data?.errors
      };
    }
  },

  // Eliminar configuración de tareo (volver a valor por defecto)
  async eliminarConfiguracionTareo(empresaId) {
    try {
      const response = await httpClient.delete(`/configuracion-tareo/empresa/${empresaId}`);
      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      console.error('Error al eliminar configuración de tareo:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al eliminar configuración de tareo'
      };
    }
  }
};

export default configuracionTareoService; 